/**
 * 사이드 네비게이션 바에 노출되는 항목들 필터링
 */
export function getFilteredPageDataList(authCtx, pageDataList) {
  const solSer = authCtx.userInfo.sol_ser || '',
        affSer = authCtx.userInfo.aff_ser || '',
        affNo = Number(authCtx.userInfo?.aff_no || 0),
        memberNo = authCtx.memberNo;

  return pageDataList.map(actions => {
    const filteredChildren = actions.children.filter(action => {
      // action.data가 없거나 빈 배열일 때 방어 처리
      if (!action.data || !action.data[0]) {
        return false;
      }
      const { authorized_m_no, authorized_aff_no, authorized_sol_ser, authorized_aff_ser, unrecognized_aff_no, exempted_m_no } = action.data[0];

      if (actions.title === '에러코드') {
        return !(action.unrecognized_aff_no?.includes(affNo) && !action.unrecognized_aff_ser.some(aff_ser => affSer.includes(aff_ser)));
      }

      const isUnrecognizedAffiliate = unrecognized_aff_no?.includes(affNo);

      const isAuthorizedMember = authorized_m_no?.length ? authorized_m_no.includes(memberNo) : false,
            isAuthorizedAffiliate = authorized_aff_no?.length ? authorized_aff_no.includes(affNo) : false,
            isAuthorizedAffSer = authorized_aff_ser?.length ? authorized_aff_ser.some(aff_ser => affSer.includes(aff_ser)) : false,
            isAuthorizedSolSer = authorized_sol_ser?.length ? authorized_sol_ser.some(sol_ser => solSer.includes(sol_ser)) : false,
            isExtemptedMember = exempted_m_no?.length ? exempted_m_no.includes(memberNo) : false; // authorized 조건 상관없이 접근 허용 대상자

      return (((!authorized_m_no?.length && !authorized_aff_no?.length && !authorized_aff_ser?.length && !authorized_sol_ser?.length)
          || isAuthorizedMember || isAuthorizedAffiliate || isAuthorizedAffSer || isAuthorizedSolSer)
        && !isUnrecognizedAffiliate) || isExtemptedMember;
    });

    return {
      ...actions,
      children: filteredChildren
    };
  }).filter(actions =>
    ((actions.children.length || actions.alwaysShow) &&
      !actions.unrecognized_aff_no?.includes(affNo) &&
      !actions.unrecognized_aff_ser?.some(aff_ser => affSer.includes(aff_ser)))
    || actions.exempted_m_no?.includes(memberNo)
  );
}

/**
 * API 버전별 노출되는 항목들 필터링
 */
export function getPageDataRawFiltered(pageDataRaw, authCtx) {
  const solSer = authCtx.userInfo.sol_ser || '',
        affSer = authCtx.userInfo.aff_ser || '',
        affNo = authCtx.affNo,
        memberNo = authCtx.memberNo;

  return {
    ...pageDataRaw,
    data: pageDataRaw.data.filter(version => {
      const { authorized_m_no, authorized_aff_no, authorized_aff_ser, authorized_sol_ser } = version;
      
      const isAuthorizedMember = authorized_m_no?.length ? authorized_m_no.includes(memberNo) : true,
            isAuthorizedAffiliate = authorized_aff_no?.length ? authorized_aff_no.includes(affNo) : true,
            isAuthorizedAffSer = authorized_aff_ser?.length ? authorized_aff_ser.some(aff_ser => affSer.includes(aff_ser)) : true,
            isAuthorizedSolSer = authorized_sol_ser?.length ? authorized_sol_ser.some(sol_ser => solSer.includes(sol_ser)) : true;
      
      return (authorized_m_no?.length && authorized_aff_no?.length && authorized_sol_ser?.length) || isAuthorizedMember || isAuthorizedAffiliate || isAuthorizedAffSer || isAuthorizedSolSer;
    })
  }
}

/**
 * 페이지별 접근 권한 검증
 */
export function getShouldValidateAccess(pageData, authCtx) {
  const solSer = authCtx.userInfo.sol_ser || '',
        affSer = authCtx.userInfo.aff_ser || '',
        affNo = authCtx.affNo,
        memberNo = authCtx.memberNo;
  const { authorized_m_no, authorized_aff_no, authorized_aff_ser, authorized_sol_ser, unrecognized_aff_no, unrecognized_aff_ser, exempted_m_no } = pageData || {};

  const isAuthorizedMember = authorized_m_no?.length ? authorized_m_no.includes(memberNo) : true,
        isAuthorizedAffiliate = authorized_aff_no?.length ? authorized_aff_no.includes(affNo) : true,
        isAuthorizedAffSer = authorized_aff_ser?.length ? authorized_aff_ser.some(aff_ser => affSer.includes(aff_ser)) : true,
        isAuthorizedSolSer = authorized_sol_ser?.length ? authorized_sol_ser.some(sol_ser => solSer.includes(sol_ser)) : true,
        isUnrecognizedAffiliate = unrecognized_aff_no?.length ? !unrecognized_aff_no.includes(affNo) : true,
        isUnrecognizedAffSer = unrecognized_aff_ser?.length ? !unrecognized_aff_ser.some(aff_ser => affSer.includes(aff_ser)) : true,
        isExtemptedMember = exempted_m_no?.length ? exempted_m_no.includes(memberNo) : false; // authorized 조건 상관없이 접근 허용 대상자

  return (((!authorized_m_no?.length && !authorized_aff_no?.length && !authorized_aff_ser?.length && !authorized_sol_ser?.length) ||
      (isAuthorizedMember || isAuthorizedAffiliate || isAuthorizedAffSer || isAuthorizedSolSer))
      && isUnrecognizedAffiliate && isUnrecognizedAffSer)
    || isExtemptedMember;
}